import { Component, EventEmitter, Input, Output } from "@angular/core";

import { AccountSetupSteps } from "src/app/core/ngrx/ui";

export interface LocateMembershipLinks {
  step: AccountSetupSteps;
  title: string;
}
@Component({
  selector: "myqq-locate-membership",
  templateUrl: "./locate-membership.component.html",
  styleUrls: ["./locate-membership.component.scss"],
})
export class LocateMembershipComponent {
  @Input() currentStep: AccountSetupSteps = AccountSetupSteps.last4lookup;
  @Output() changeLocateStep = new EventEmitter<AccountSetupSteps>();

  readonly steps = AccountSetupSteps;

  links: LocateMembershipLinks[] = [
    { step: this.steps.last4lookup, title: "Vehicle Info" },
    { step: this.steps.enter_credit_card_details, title: "Credit card" },
  ];
}
